<mat-card class="fade-in proviaje-last-item">
    <mat-card-header>
      <mat-card-title>Lista de estudiantes</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="table-container">
        <app-table-users (toggleStatusEvent)="toggleSellerStatusEvent($event)" (deleteEvent)="deleteSellerEvent($event)"  [sellerList]="sellerList" userType="admin" userIdentifier="adminTable" [adminColumns]="'admin'"></app-table-users>
      </div>
    </mat-card-content>
</mat-card>